import React from 'react';
import { authRoles } from 'app/auth';

const ForgetPasswordConfig = {
	settings: {
		layout: {
			config: {
				navbar: {
					display: false
				},
				toolbar: {
					display: false
				},
				footer: {
					display: false
				},
				leftSidePanel: {
					display: false
				},
				rightSidePanel: {
					display: false
				}
			}
		}
	},
	auth: authRoles.onlyGuest,
	routes: [
		{
			path: '/forget-password',
			component: React.lazy(() => import('./index'))
		}
	]
};

export default ForgetPasswordConfig;
